import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Stack, List, ListItem } from '@mui/material';
import SpaIcon from '@mui/icons-material/Spa';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

export const tips = [
  {
    title: 'Spring Declutter',
    description: 'Sort and donate unused items to refresh your home for the new season.',
  },
  {
    title: 'Summer Deep Clean',
    description: 'Wash windows, clean patio furniture, and check air filters for a healthy summer home.',
  },
  {
    title: 'Fall Prep',
    description: 'Clean gutters, check weather stripping, and vacuum behind appliances before winter.',
  },
  {
    title: 'Pro Tip: Rotate Bedding',
    description: 'Switch to lighter or heavier bedding as the seasons change for comfort and cleanliness.',
    pro: true,
  },
  {
    title: 'Holiday Ready',
    description: 'Dust guest rooms and clean the oven before hosting holiday gatherings.',
  },
  {
    title: 'Allergy Control',
    description: 'Vacuum carpets and wash curtains regularly to reduce seasonal allergens.',
  },
];

const detailedSeasonalTips = {
  spring: [
    'Rent a steam-cleaner for carpets and upholstery.',
    'Flip or rotate rugs outdoors in the sun to kill allergens and restore plumpness.',
  ],
  summer: [
    'Wash windowscreens with mild soap to reduce pollen infiltration.',
    'Install hygrometers and run dehumidifiers at 50–55% RH to inhibit mold growth.',
  ],
  fall: [
    'Vacuum and seal attic vents before first frost.',
    'Recaulk exterior windows and doors to save energy.',
  ],
  winter: [
    'Keep entryway mats layered—coarse mat outside, absorbent mat inside—to stop road salt and moisture at the door.',
    'Wipe tile and grout weekly to remove salt residue before it etches.',
  ],
};

const SeasonalTips = () => (
  <Box sx={{ mb: 6 }}>
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <SpaIcon color="primary" sx={{ fontSize: 40 }} />
      <Typography variant="h4" fontWeight={700}>
        Seasonal Cleaning Tips
      </Typography>
    </Stack>
    <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
      Keep your home fresh and ready for every season with these tips!
    </Typography>
    <Grid container spacing={3}>
      {tips.map((tip, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 1 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
                  {tip.title}
                </Typography>
                {tip.pro && (
                  <Chip icon={<EmojiObjectsIcon />} label="Pro Tip" color="warning" size="small" />
                )}
              </Stack>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                {tip.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
    {/* Detailed Seasonal Tips Section */}
    <Box sx={{ mt: 6 }}>
      {Object.entries(detailedSeasonalTips).map(([season, tipsArr]) => (
        <Box key={season} sx={{ mb: 3 }}>
          <Typography variant="h6" fontWeight={600} sx={{ textTransform: 'capitalize', mb: 1 }}>
            {season} Tips
          </Typography>
          <List dense>
            {tipsArr.map((tip, idx) => (
              <ListItem key={idx} sx={{ pl: 0 }}>
                <Typography variant="body2">• {tip}</Typography>
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Button variant="contained" color="primary" size="large">
        See all seasonal tips
      </Button>
    </Box>
  </Box>
);

export default SeasonalTips; 